/**
 * About Us – Motion inView for map path animation and dot reveal.
 * Animates SVG paths (Wyoming/Colorado regions) and location dots when block scrolls into view.
 */

import { inView, animate } from 'motion';

function initAboutUs() {
  const blocks = document.querySelectorAll('.wp-block-acf-about-us');
  blocks.forEach((block) => {
    const mapCard = block.querySelector('.wp-block-acf-about-us__map-card');
    if (!mapCard) return;

    inView(
      mapCard,
      () => {
        const paths = block.querySelectorAll('.wp-block-acf-about-us__map-path');
        const dots = block.querySelectorAll('.wp-block-acf-about-us__map-dot');
        const lines = block.querySelectorAll('.wp-block-acf-about-us__map-line');

        paths.forEach((path, i) => {
          animate(
            path,
            { pathLength: [0, 1], opacity: [0, 1] },
            { duration: 1.5, ease: 'ease-in-out', delay: i * 0.5 }
          );
        });

        lines.forEach((line) => {
          animate(
            line,
            { pathLength: [0, 1], opacity: [0, 0.1] },
            { duration: 1, delay: 1 }
          );
        });

        dots.forEach((dot, i) => {
          animate(
            dot,
            { opacity: [0, 1], scale: [0, 1] },
            { duration: 0.6, delay: 1 + i * 0.1 }
          );
        });
      },
      { once: true }
    );
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAboutUs);
} else {
  initAboutUs();
}
